import {http} from '@services/utils';

import {type GetPermissionsResponse, GetPermissionsResponseSchema} from './getPermissions.schema';

/**
 * GET `auth/permission` — все permission'ы текущего юзера.
 * Доступно после логина с general-токеном (до scoped-token обмена).
 */
export const getPermissions = async (): Promise<GetPermissionsResponse> => {
  const raw = await http('auth/permission');
  return GetPermissionsResponseSchema.parse(raw);
};
